const mMessageId = new WeakMap();
const mMessageType = new WeakMap();
const mMessageText = new WeakMap();
const mMessageTimeout = new WeakMap();

class Message {
    constructor(msgId, msgType, msgText, msgTimeout = null) {
        if (msgId != null) {
            mMessageId.set(this, msgId);
        }
        else {
            throw new TypeError("Missing Message Id");
        }

        mMessageType.set(this, msgType);
        mMessageText.set(this, msgText);

        if ((Number.isInteger(msgTimeout)) && (msgTimeout > 0)) {
            mMessageTimeout.set(this, msgTimeout);
        }
        else {
            mMessageTimeout.set(this, null);
        }
    }

    get messageId() {
        return mMessageId.get(this);
    }

    get messageType() {
        return mMessageType.get(this);
    }

    get messageText() {
        return mMessageText.get(this);
    }

    get messageTimeout() {
        return mMessageTimeout.get(this);
    }
}

export default Message;


//////////////////
// WEBPACK FOOTER
// ./src/models/Message.js
// module id = n5HP
// module chunks = 1